"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactEmotion = require("react-emotion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var fade = /*#__PURE__*/(0, _reactEmotion.keyframes)("from{opacity:0;}to{opacity:1;}");
var fadeOut = /*#__PURE__*/(0, _reactEmotion.keyframes)("from{opacity:1;}to{opacity:0;}");

var Content = /*#__PURE__*/function (_React$Component) {
  _inherits(Content, _React$Component);

  var _super = _createSuper(Content);

  function Content(props) {
    var _this;

    _classCallCheck(this, Content);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "keydown", function (e) {
      if (e.keyCode != 27) return;

      _this.shouldConfirmBeforeClosing();
    });

    _defineProperty(_assertThisInitialized(_this), "click", function (e) {
      if (_this.modal) {
        if (_this.modal.contains(e.target) || !_this.props.clickOutsideCloses) return;else _this.shouldConfirmBeforeClosing();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "shouldConfirmBeforeClosing", function () {
      if (_this.props.showConfirmationOnClose) _this.setState({
        show_confirm_close: true
      });else _this.close();
    });

    _defineProperty(_assertThisInitialized(_this), "cancelClose", function () {
      _this.setState({
        show_confirm_close: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.setState({
        closing: true
      }, function () {
        return setTimeout(function () {
          return _this.props.onClose();
        }, 200);
      });
    });

    _this.state = {
      show_confirm_close: false,
      closing: false
    };
    return _this;
  }

  _createClass(Content, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.click, false);
      document.addEventListener('keydown', this.keydown, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.click, false);
      document.removeEventListener('keydown', this.keydown, false);
    }
  }, {
    key: "getModalContentStyle",
    value: function getModalContentStyle() {
      var width = this.props.width;
      var styles = {
        1: {
          maxWidth: '36rem'
        },
        2: {
          maxWidth: '48rem'
        },
        3: {
          maxWidth: '64rem'
        }
      };
      return styles[width || 1];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var dark = this.props.theme === 'dark';
      if (!this.props.open) return null;else {
        var content = /*#__PURE__*/_react.default.createElement("div", {
          className: /*#__PURE__*/(0, _emotion.css)("position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.7);opacity:0;animation:", this.state.closing ? fadeOut : fade, " .2s ease-in forwards;z-index:10;overflow:auto;text-align:center;"),
          "data-test-id": "test-modal"
        }, /*#__PURE__*/_react.default.createElement("div", {
          "data-test-id": "test-modal-inner",
          ref: function ref(_ref) {
            return _this2.modal = _ref;
          },
          style: this.getModalContentStyle(),
          className: /*#__PURE__*/(0, _emotion.css)("background:", dark ? '#222' : 'white', ";color:", dark ? '#ccc' : 'inherit', ";border-radius:3px;padding:2rem;margin:3rem 0;max-width:36rem;width:100%;text-align:left;display:inline-block;")
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _emotion.merge)( /*#__PURE__*/(0, _emotion.css)("margin:-2rem -2rem 0;border-top-left-radius:3px;border-top-right-radius:3px;height:72px;", dark ? 'background: #111' : '', ";") + (" " + "flex items-center ".concat(dark ? '' : 'bg-gray-6', " px3")))
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "flex-auto pr3 truncate"
        }, typeof this.props.title === 'string' ? /*#__PURE__*/_react.default.createElement("h4", {
          className: "mb0"
        }, this.props.title) : this.props.title), /*#__PURE__*/_react.default.createElement("div", {
          className: "flex items-center justify-end",
          style: {
            width: '60px'
          }
        }, !this.state.show_confirm_close && this.props.isDismissable && /*#__PURE__*/_react.default.createElement("button", {
          "data-test-id": "test-modal-close-btn",
          onClick: this.shouldConfirmBeforeClosing,
          className: (0, _emotion.merge)( /*#__PURE__*/(0, _emotion.css)("color:", dark ? '#ccc !important' : 'inherit', ";") + (" " + "cs-button link material-icons"))
        }, "close"))), /*#__PURE__*/_react.default.createElement("div", {
          className: "py4 center ".concat(this.state.show_confirm_close ? 'block' : 'display-none')
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            fontSize: '36px'
          },
          className: "material-icons block large-icon muted"
        }, "error"), /*#__PURE__*/_react.default.createElement("h4", {
          className: "mb0"
        }, "Are you sure you want to close?"), /*#__PURE__*/_react.default.createElement("div", {
          className: "flex items-center justify-center mt2"
        }, /*#__PURE__*/_react.default.createElement("button", {
          "data-test-id": "test-modal-cancel-close",
          onClick: this.cancelClose,
          style: {
            width: '100px'
          },
          className: "cs-button mr1 small white"
        }, "Continue"), /*#__PURE__*/_react.default.createElement("button", {
          "data-test-id": "test-modal-confirm-close",
          onClick: this.close,
          style: {
            width: '100px'
          },
          className: "cs-button mr1 small"
        }, "Close"))), /*#__PURE__*/_react.default.createElement("div", {
          "data-test-id": "test-modal-content",
          className: "pt3 ".concat(this.state.show_confirm_close ? 'display-none' : 'block')
        }, this.props.children)));

        return _reactDom.default.createPortal(content, document.body);
      }
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Content;
}(_react.default.Component);

Content.defaultProps = {
  width: 1
};
Content.propTypes = {
  open: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  showConfirmationOnClose: _propTypes.default.bool,
  clickOutsideCloses: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  testId: _propTypes.default.string,
  width: _propTypes.default.oneOf([1, 2, 3]),
  isDismissable: _propTypes.default.bool,
  theme: _propTypes.default.string.isRequired
};
var _default = Content;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(fade, "fade", "/Users/darcy/sites/cs-theme/src/components/modal/content.js");
  reactHotLoader.register(fadeOut, "fadeOut", "/Users/darcy/sites/cs-theme/src/components/modal/content.js");
  reactHotLoader.register(Content, "Content", "/Users/darcy/sites/cs-theme/src/components/modal/content.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/modal/content.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();